import { createContext, type Context } from 'react';

import { ProductEnvironment } from '@atlassian/forge-ui-types/environments';

export const EnvironmentContext: Context<ProductEnvironment> = createContext<ProductEnvironment>(
	ProductEnvironment.PRODUCTION,
);
